<template>
  <div>
    <first-component :classifyId="6"></first-component>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style>
.all-content {
  width: 1100px;
  margin: 0 auto;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);

  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/OnlineSearch.vue